import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { INotificacionesPush } from '../interfaces/generales/INotificacionesPush'

export class NotificacionPushService extends BaseService<INotificacionesPush> {
  constructor() {
    super({
        baseUrl: 'notification/push/'
    })
  }

  async createMultiple(
    data: INotificacionesPush[]
  ): Promise<AxiosResponse<IResponseApi<INotificacionesPush[]>>> {
    return await this.http.post<IResponseApi<INotificacionesPush[]>>(`/create-multi`, data)
  }
}
